import React, { useEffect, useState } from 'react';

import queryString from 'querystring';
import { useDispatch } from 'react-redux';
import { GetTitle } from './boardTitle';
import { getBreadScrumb } from './breadscrumb';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function ReplyView(routeProps: any) {
  const option: any = queryString.decode(routeProps.location.search.substring(1));
  const [reply, setReply] = useState<any>();
  const dispatch = useDispatch();
  const [deleted, setDelete] = useState(true);
  const [update, setUpdate] = useState(true);
  // const [boardItem, setBoardItem] = useState(false);
  const viewButton = window.localStorage.getItem('token') !== null;
  const admin = window.localStorage.getItem('authority') === 'A';

  useEffect(() => {
    server.getReplyId(option.id).then((payload) => {
      if (!payload) {
        dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
      } else if (payload.code === 260 || payload.code === 500) {
        dispatch(toast.error({ message: '파라미터 오류' }));
      } else {
        setReply(payload);
      }
    });

    if (
      viewButton &&
      routeProps.location.state !== undefined &&
      routeProps.location.state.delete !== undefined &&
      routeProps.location.state.delete
    ) {
      setDelete(routeProps.location.state.delete);
    }
    if (
      // 동일 계정일 경우 수정 가능 하도록 수정
      viewButton &&
      routeProps.location.state !== undefined &&
      routeProps.location.state.update !== undefined &&
      routeProps.location.state.update
    ) {
      setUpdate(routeProps.location.state.update);
    }
    if (
      viewButton &&
      routeProps.location.state !== undefined &&
      routeProps.location.state.replie !== undefined &&
      routeProps.location.state.replie
    ) {
      setReply(routeProps.location.state.replie);
    }
  }, []);

  // const attachFile = (fileList: string[], fileUrl: string[]) => {
  //   const ret: any = [];

  //   for (let i = 0; i < fileList.length; i++) {
  //     if (fileList[i].length !== 0) {
  //       ret.push(
  //         <li key={i}>
  //           <button
  //             className="btn-file"
  //             type="button"
  //             onClick={() => {
  //               window.location.href = `${process.env.REACT_APP_API_URL}/public${fileUrl[i]}`;
  //             }}
  //           >
  //             {fileList[i]}
  //           </button>
  //         </li>
  //       );
  //     }
  //   }
  //   return ret;
  // };

  const getDeleteButton = () => {
    if (deleted)
      return (
        <button
          className="btn-sub"
          type="button"
          key={option.id}
          onClick={() => {
            if (window.confirm('정말 삭제하시겠습니까?')) {
              server.deleteReply(option.ctgy, option.id).then((payload) => {
                if (!payload) {
                  dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                } else if (payload.code === 260 || payload.code === 500) {
                  dispatch(toast.error({ message: '파라미터 오류' }));
                } else {
                  routeProps.history.goBack();
                }
              });
            }
          }}
        >
          삭제
        </button>
      );

    return <></>;
  };
  const getUpdateButton = () => {
    if (update)
      return (
        <button
          type="button"
          key={option.id}
          onClick={() => {
            const op = {
              ...option,
              update: true,
            };
            routeProps.history.push({
              pathname: '/board/replyWriter',
              search: `?${new URLSearchParams(op).toString()}`,
              state: reply,
            });
          }}
        >
          수정
        </button>
      );
    return <></>;
  };

  // const getReplieButton = () => {
  //   if (reply)
  //     return (
  //       <button
  //         type="button"
  //         onClick={() => {
  //           const op = {
  //             ...option,
  //             reply: true,
  //           };
  //           routeProps.history.push({
  //             pathname: '/board/replyWriter',
  //             search: `?${new URLSearchParams(op).toString()}`,
  //           });
  //         }}
  //       >
  //         답글
  //       </button>
  //     );
  //   return <></>;
  // };

  const getButton = () => {
    return (
      <div className="view-footer">
        <button
          className="btn-sub"
          type="button"
          onClick={() => {
            routeProps.history.goBack();
          }}
        >
          목록
        </button>
        {admin && getDeleteButton()}
        {admin && getUpdateButton()}
        {/* {getReplieButton()} */}
      </div>
    );
  };

  return (
    <div className="content">
      {getBreadScrumb(option.title.toString())}
      {GetTitle(
        option.ctgy,
        option.title.toString(),
        option.subTitle.toString(),
        '',
        '',
        false,
        () => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {}
      )}
      <div className="view-content">
        <div className="view-header">
          <div className="view-title">{reply?.subject}</div>
          <div className="writer">{reply?.writer?.name}</div>
          <ul>
            <li className="date">
              {reply === undefined ? '' : new Date(reply.modDate).toLocaleDateString()}
            </li>
          </ul>
          {/* <ul className="files">
            <li>
              <svg
                className="ico-file"
                xmlns="http://www.w3.org/2000/svg"
                height="18"
                viewBox="0 0 24 24"
                width="18"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
              </svg>
              <span>첨부파일:</span>
            </li>
            {attachFile}
          </ul> */}
        </div>
        <div className="description">
          <pre>{reply?.content}</pre>
        </div>
      </div>
      {getButton()}
    </div>
  );
}
